"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var defaultContract_1 = __importDefault(require("./defaultContract"));
var UserLight = /** @class */ (function () {
    function UserLight(props) {
        this.clientId = props.clientId;
        this.firstName = props.firstName;
        this.lastName = props.lastName;
        this.defaultContractId = props.defaultContractId;
        this.defaultDeliveryPointId = props.defaultDeliveryPointId;
        this.defaultContract = props.defaultContract ? new defaultContract_1.default(props.defaultContract) : null;
        this.defaultSectionId = props.defaultSectionId;
        this.clientReference = props.clientReference;
        this.defaultCustomerAccountId = props.defaultCustomerAccountId;
        this.defaultSectionIds = [props.defaultSectionId];
        this.isFamilyMode = false;
        this.defaultFamilyId = "";
        this.isEligibleCoachConso = props.isEligibleCoachConso;
        this.pairingTechnologyCode = props.pairingTechnologyCode;
        this.isEligibleNewFeaturesMessage = props.isEligibleNewFeaturesMessage;
        this.isMultiTargetAlertsEnabled = props.isMultiTargetAlertsEnabled;
    }
    return UserLight;
}());
exports.default = UserLight;
